<script setup lang="ts">
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
type Props = {
  id?: string
  title?: any
  items: { id: string; fields: { title: any; text: any } }[]
  contentType?: string
}
const props = defineProps<Props>()
const panelId = props.id
const panelTitle = props.title // this 'document' nodeType also includes panel Description 'paragraph'
const accordionItems = props.items
  .filter((i) => i.fields) // filter out items without fields
  .map(({ id, fields: { title, text } }: { id: string; fields: { title: any; text: any } }) => ({
    id,
    title, // accordionItem Title
    text, // accordionItem Description
  }))

if (props.contentType === 'FAQ') {
  const { registerFaqPageQuestions } = useSchemaOrg()

  registerFaqPageQuestions(
    accordionItems.map((item) => ({
      question: documentToPlainTextString(item.title),
      answer: documentToPlainTextString(item.text),
    })),
  )
}
</script>

<template>
  <div class="accordion-panel container" data-testid="accordion-panel">
    <div v-if="panelTitle" class="accordion-panel__title">
      <RichText :document="panelTitle" />
    </div>
    <Accordion
      v-for="{ id, title, text } of accordionItems"
      :key="id"
      :ga-options="{ group: 'content' }"
      :name="panelId"
      panel-test-id="accordion-panel__item"
      test-id="accordion-panel__question"
    >
      <template #title>
        <RichText :document="title" class="accordion-title" />
      </template>
      <RichText :document="text" data-testid="accordion-panel__answer" />
    </Accordion>
  </div>
</template>

<style lang="postcss">
.accordion-panel {
  max-width: 40rem;

  .accordion-title {
    width: calc(100% - var(--space-80));

    p {
      margin-bottom: 0;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      text-transform: none;
      margin-bottom: 0;
    }
  }

  .accordion summary {
    font-size: var(--text-base);
  }
}
</style>
